import React, { useState, useMemo } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';

const MoveTransactionDialog = ({
  open,
  onOpenChange,
  selectedTransactions,
  allDeals,
  currentDealId,
  targetDealId,
  setTargetDealId,
  onMove,
  onCancel
}) => {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return allDeals
      .filter(d => d.id !== currentDealId)
      .filter(d =>
        !q ||
        String(d.deal_id || '').includes(q) ||
        (d.deal_name || '').toLowerCase().includes(q) ||
        (d.merchant_name || '').toLowerCase().includes(q)
      )
      .slice(0, 50);
  }, [allDeals, currentDealId, search]);

  const selectedDeal = allDeals.find(d => d.id === targetDealId);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="move-transaction-dialog">
        <DialogHeader>
          <DialogTitle>Move Transactions to Another Deal</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <div>
            <Label htmlFor="dealSearch">Search Deal (by ID or name)</Label>
            <Input
              id="dealSearch"
              data-testid="move-deal-search"
              placeholder="Type deal ID or merchant name..."
              value={search}
              onChange={e => { setSearch(e.target.value); setTargetDealId(''); }}
              className="mt-1"
            />
          </div>

          {search && (
            <div className="border rounded max-h-48 overflow-y-auto" data-testid="move-deal-results">
              {filtered.length === 0 ? (
                <p className="p-3 text-sm text-gray-500">No deals found</p>
              ) : (
                filtered.map(deal => (
                  <button
                    key={deal.id}
                    data-testid={`move-deal-option-${deal.deal_id}`}
                    onClick={() => { setTargetDealId(deal.id); setSearch(''); }}
                    className={`w-full text-left px-3 py-2 text-sm hover:bg-blue-50 border-b last:border-b-0 ${
                      targetDealId === deal.id ? 'bg-blue-100 font-medium' : ''
                    }`}
                  >
                    <span className="font-semibold">#{deal.deal_id}</span>
                    <span className="ml-2 text-gray-600">{deal.deal_name || deal.merchant_name || ''}</span>
                  </button>
                ))
              )}
            </div>
          )}

          {selectedDeal && !search && (
            <div className="bg-blue-50 border border-blue-200 p-2 rounded text-sm">
              Target: <strong>#{selectedDeal.deal_id}</strong> — {selectedDeal.deal_name || selectedDeal.merchant_name || ''}
            </div>
          )}

          <div className="bg-yellow-50 border border-yellow-200 p-3 rounded">
            <p className="text-sm text-yellow-800">
              <strong>Note:</strong> This will move {selectedTransactions.length} transaction(s) to the selected deal and recalculate balances for both deals.
            </p>
          </div>
          <div className="flex justify-end space-x-2">
            <Button type="button" variant="outline" onClick={onCancel}>
              Cancel
            </Button>
            <Button onClick={onMove} disabled={!targetDealId}>Move Transactions</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MoveTransactionDialog;
